import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';
import { usePushSubscription } from '@ms/yammer-hooks/dist/pushSubscriptions';
import { useServiceWorkerMessages } from '@ms/yammer-hooks/dist/pwa';
import { useSendPresenceState } from '@ms/yammer-hooks/dist/userPresence';
import { usePersistLocale } from '@ms/yammer-i18n-react/dist/hooks';
import { ReduxAnnouncerBridge } from '@ms/yammer-web-components/dist/accessibility/Announcer';
import Skiplink from '@ms/yammer-web-components/dist/accessibility/Skiplink';
import AppContextProvider from '@ms/yammer-web-components/dist/app/AppContext';
import AppDocumentLanguage from '@ms/yammer-web-components/dist/app/AppDocumentLanguage';
import IE11GatedContent from '@ms/yammer-web-components/dist/browserDeprecation/IE11GatedContent';
import MediaLightbox from '@ms/yammer-web-components/dist/messageAttachments/MediaLightbox';
import RealtimeClient from '@ms/yammer-web-components/dist/realtime/RealtimeClient';
import SessionContextProviderWithHooks from '@ms/yammer-web-components/dist/session/SessionContextProviderWithHooks';
import AppContainer from '@ms/yammer-web-core-ui/dist/components/AppContainer';
import { PageLayoutContentMainAreaAriaRole } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { usePrepareIcons } from '@ms/yammer-web-core-ui/dist/util/icons';
import React, { FC } from 'react';

import Dialogs from '../Dialogs';
import Routes from '../Routes';

import { useThemeWithSuiteHeaderOverrides } from './hooks';

const App: FC = () => {
  usePersistLocale();
  useServiceWorkerMessages();
  usePushSubscription();
  useSendPresenceState();
  const theme = useThemeWithSuiteHeaderOverrides();
  const isFluentRedesignEnabled = useAndReportExperimentTreatment(Experiment.FluentRedesign) === 'enabled';
  usePrepareIcons(isFluentRedesignEnabled);

  return (
    <AppContainer theme={theme} useFluentRedesign={isFluentRedesignEnabled}>
      <SessionContextProviderWithHooks>
        <AppContextProvider mainAreaAriaRole={PageLayoutContentMainAreaAriaRole.Main}>
          <AppDocumentLanguage />
          <IE11GatedContent>
            <Skiplink />
            <Routes />
            <Dialogs />
            <MediaLightbox />
            <RealtimeClient />
            <ReduxAnnouncerBridge />
          </IE11GatedContent>
        </AppContextProvider>
      </SessionContextProviderWithHooks>
    </AppContainer>
  );
};
export default App;
